import React from 'react';
import {
  EVBox,
  EVIconButton,
  EVClear,
} from '@eagleview/ev-comp-library';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import useStyles from './NotificationStyle';

const Notification = ({ templateContent, handleArchiveClick }) => {
  const classes = useStyles();
  return (
    <EVBox className={clsx(classes.box)}>
      <EVBox className={clsx(classes.textBox)}>
        <div className={clsx(classes.notificationText)} dangerouslySetInnerHTML={{ __html: templateContent }} />
        <EVIconButton
          id="clearMessage"
          aria-label="clear"
          onClick={() => handleArchiveClick({ })}
          className={clsx(classes.notitfactionClearButton)}
        >
          <EVClear className={clsx(classes.clearIcon)} />
        </EVIconButton>
      </EVBox>
    </EVBox>
  );
};

Notification.propTypes = {
  templateContent: PropTypes.string,
  handleArchiveClick: PropTypes.func,
};

Notification.defaultProps = {
  templateContent: '',
  handleArchiveClick: () => {},
};

export default Notification;
